export enum EFieldGroupName {
  About = 'about',
  Area = 'area',
  General = 'general',
}

export enum EFieldName {
  /** Фотографии **/
  Photos = 'photos',
  /** Адрес **/
  Address = 'address',
  /** Количество балконов и лоджий **/
  Balconies = 'balconies',
  /** Год постройки **/
  BuildYear = 'buildYear',
  /** Застройщик **/
  Builder = 'builder',
  /** Новостройка или вторичка **/
  CategoryName = 'categoryName',
  /** Высота потолков, м **/
  CeilingHeight = 'ceilingHeight',
  /** Контакты **/
  Contacts = 'contacts',
  /** Дата сдачи **/
  FinishDate = 'finishDate',
  /** Отделка **/
  Finishing = 'finishing',
  /** Этаж **/
  Floor = 'floor',
  /** Класс дома **/
  HouseClass = 'houseClass',
  /** Количество корпусов **/
  HouseCount = 'houseCount',
  /** Корпус **/
  HouseName = 'houseName',
  /** На территории ЖК **/
  Infrastructure = 'infrastructure',
  /** Площадь кухни **/
  KitchenArea = 'kitchenArea',
  /** Жилая площадь **/
  LivingArea = 'livingArea',
  /** Лифты **/
  Lifts = 'lifts',
  /** Местоположение **/
  Location = 'location',
  /** Тип дома **/
  MaterialType = 'materialType',
  /** Возможна ли ипотека **/
  Mortgage = 'mortgage',
  /** Название ЖК **/
  NewbuildingName = 'newbuildingName',
  /** Парковка **/
  Parking = 'parking',
  /** Цена **/
  Price = 'price',
  /** Цена за квадратный метр **/
  PriceForMeter = 'priceForMeter',
  /** Тип ремонта **/
  RepairType = 'repairType',
  /** Начало строительства **/
  StartDate = 'startDate',
  /** Заголовок объявления ('2-комн. апарт., 111,9 м², 9/10') **/
  Title = 'title',
  /** Общая площадь **/
  TotalArea = 'totalArea',
  /** Санузел **/
  WC = 'wc',
  /** Вид из окон **/
  WindowsView = 'windowsView',
}

export interface IField {
  name: EFieldGroupName;
  items: EFieldName[];
}
